import React from "react";

const FullscreenLoader = ({ message = "Processing..." }) => (
  <div
    className="fullscreen-loader"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="spinner-border text-primary" />
    <p className="lead mt-3">{message}</p>
  </div>
);

export default FullscreenLoader;
